import { render, staticRenderFns } from "./ScreenShot.vue?vue&type=template&id=2fc99338"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"
import style0 from "./ScreenShot.vue?vue&type=style&index=0&id=2fc99338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports